import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { toast } from "sonner";
import { Shield } from "lucide-react";

export const Route = createFileRoute("/admin/settings")({ component: SettingsPage });

function SettingsPage() {
  const [adminCount] = useState(0);

  const promoteSelf = async () => {
    // TODO: bind Admin-access API (React Query mutation)
    toast("Settings API not connected yet");
  };

  return (
    <div className="max-w-2xl space-y-5">
      <div>
        <h2 className="font-serif text-2xl font-bold">Settings</h2>
        <p className="text-sm text-muted-foreground">Yatra configuration & access</p>
      </div>

      <div className="rounded-2xl border border-border bg-card p-6">
        <h3 className="font-serif text-lg font-bold">Yatra Info</h3>
        <div className="mt-4 space-y-4">
          {[
            { l: "Yatra Name", k: "name" },
            { l: "City", k: "city" },
            { l: "Helpline", k: "helpline" },
          ].map((f) => (
            <div key={f.k}>
              <label className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">
                {f.l}
              </label>
              {/* TODO: bind Yatra Info API (React Query) */}
              <input
                placeholder={f.l}
                className="mt-1 w-full rounded-xl border border-border bg-background px-4 py-2.5 text-sm outline-none focus:border-primary"
              />
            </div>
          ))}
        </div>
      </div>

      <div className="rounded-2xl border border-border bg-card p-6">
        <h3 className="flex items-center gap-2 font-serif text-lg font-bold">
          <Shield className="h-4 w-4 text-primary" /> Admin Access
        </h3>
        <p className="mt-1 text-sm text-muted-foreground">
          {adminCount} admin{adminCount !== 1 ? "s" : ""} configured.
        </p>
        <p className="mt-2 text-xs text-muted-foreground">
          Use the Members page to promote/demote admins. The first admin can self-promote here.
        </p>
        <button onClick={promoteSelf} className="btn-primary mt-3 py-2 text-sm">
          Make me first admin
        </button>
      </div>
    </div>
  );
}
